<template>
    <v-container id="legislatif">
        <v-card>
            <v-card-title class="title_display" @click="show.legislatif=!show.legislatif">
                <v-layout justify-space-between>
                    <h2>
                        Informations juridiques
                    </h2>
                    <v-icon large right>
                        {{ show.legislatif ? 'arrow_drop_down' : 'arrow_left' }}
                    </v-icon>
                </v-layout>
            </v-card-title>
            <transition name="fade">
                <v-container v-if="show.legislatif" fluid>
                    <p>
                        La Taxe locale sur la publicité extérieure (TLPE) a été instituée par la loi du 4 août 2008 dite de modernisation de l’économie (article 171 de la loi n°2008-776 dite loi LME), et mis en place par les communes ou l'établissement public de coopération intercommunal (EPCI), sur le territoire desquels sont situés les supports publicitaires.
                    </p>
                    <p>
                        Cette taxe frappe les supports publicitaires fixes suivants, définis à l’article L. 581-3 du Code de l’Environnement, visibles de toute voie ouverte à la circulation publique, au sens de l’article R. 581-1 du même code, à l’exception de ceux situés à l’intérieur d’un local au sens de l’article L. 581-2 dudit code.
                    </p>
                    <p>
                        Par voies ouvertes à la circulation publique au sens de l’article L. 581-2, il faut entendre les voies publiques ou privées qui peuvent être librement empruntées, à titre gratuit ou non, par toute personne circulant à pied ou par un moyen de transport individuel ou collectif.
                    </p>
                    <p>
                        Elle est due par l'exploitant du support publicitaire, le propriétaire ou celui dans l'intérêt duquel le support est réalisé.
                    </p>
                    <p>
                        Le montant de la taxe varie selon les caractéristiques et la surface des supports publicitaires.
                    </p>
                    <p>
                        La loi de finances pour 2022 apporte des changements quant à l’obligation de déclaration au titre de cette taxe. Dorénavant, cette déclaration n’est obligatoire qu’en cas de modifications de vos supports publicitaires. Celle-ci doit être réalisée avant le 30 juin de l’année en cours via le formulaire CERFA n°15702*02. A compter du 1er septembre, un titre de recette sera émis par le Trésor public .
                    </p>
                    <p>
                        Afin, d’évaluer, de maintenir ou de réduire le montant de votre taxe, nous avons mis à votre disposition cet outil de simulation TLPE.
                    </p>
                    <p>
                        Plus d'explication sur
                        <a href="https://www.service-public.fr/professionnels-entreprises/vosdroits/F22591" class="link" target="_blank">
                            service-public.fr
                        </a>
                    </p>
                </v-container>
            </transition>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Legislatif',
    components: {},
    mixins: [],
    props: {},
    data() {
        return {};
    },
    computed: {
        ...mapState('show', ['show']),
    },
    watch: {},
    created() {

    },
    methods: {},
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Simulateur/Legislatif.vue